<template>
  <div class="footer wp1">
    <div class="conbox">
      <div class="logobox">
        <img src="/images/logo_g.png" class="logo" alt="" />
      </div>
      <div class="listflex">
        <div class="list">
          <a class="tit">{{ t('menu.company') }}</a>
          <a class="txt" href="/about/" target="_blank">{{ t('menu.aboutUs') }}</a>
          <!--<a class="txt">Customer Testimonials</a>-->
          <a class="txt" href="/registrationByGroup/" target="_blank">{{
            t('menu.largeGroupPartnership')
          }}</a>
          <a class="txt" href="/partner/" target="_blank">{{ t('menu.partneringWith') }}</a>
           <a class="txt" href="https://inspiration.triptogo.com" target="_blank">Travel Inspiration</a>
        </div>
        <div class="list">
          <a class="tit">{{ t('menu.travelServiceProviders') }}</a>
          <a class="txt" href="/workwithus/" target="_blank">{{ t('menu.workingWith') }}</a>
          <a class="txt" href="https://data.triptogo.com/operator/" target="_blank">{{
            t('menu.operatorPortal')
          }}</a>
          <a class="txt" href="/registration/" target="_blank">{{
            t('menu.operatorRegistration')
          }}</a>
        </div>
        <div class="list">
          <a class="tit">{{ t('menu.travelAgents') }}</a>
          <a class="txt" href="/agentlogin/#agencyLogin" target="_blank">{{
            t('menu.agentsLogIn')
          }}</a>
          <a class="txt" href="/agentlogin/#agencyRegister" target="_blank">{{
            t('menu.agentRegistration')
          }}</a>
          <a class="txt" href="/agentFaq/" target="_blank">{{ t('menu.agentFAQ') }}</a>
          <a class="txt" href="/contactUs/?agent=1" target="_blank">{{
            t('menu.agentContactUs')
          }}</a>
        </div>
        <div class="list">
          <a class="tit">{{ t('menu.travelInsurance') }}</a>
          <a class="txt" href="/insurance/" target="_blank">{{ t('menu.travelProtection') }}</a>
          <!--<a class="txt"href="https://www.igoinsured.com/direct/start.aspx?ag=TRTOGO" target="_blank">Canada Protection Plan</a> -->
        </div>
      </div>
      <div class="listflex">
        <div class="list">
          <a class="tit">{{ t('common.policy') }}</a>
          <a class="txt" href="/terms/?title=general" target="_blank">{{ t('menu.general') }}</a>
          <a class="txt" href="/terms/?title=privacy" target="_blank">{{ t('menu.privacy') }}</a>
          <a class="txt" href="/terms/?title=refund" target="_blank">{{ t('menu.fefund') }}</a>
          <a class="txt" href="/terms/?title=cookies" target="_blank">{{ t('menu.cookies') }}</a>
        </div>
        <div class="list">
          <a class="tit">{{ t('common.membership') }}</a>
          <a class="txt" v-gtag:click="'membership_footer'" href="/membership" target="_blank">{{
            t('menu.joinNow')
          }}</a>
        </div>
        <div class="list">
          <a class="tit">{{ t('menu.visaAdvisory') }}</a>
          <a class="txt" href="/visa" target="_blank">{{ t('menu.visaAssistance') }}</a>
          <a class="txt" href="https://cibtvisas.com/?login=triptogo" target="_blank">{{
            t('menu.visaApplication')
          }}</a>
        </div>
        <div class="list">
          <a class="tit">{{ t('menu.support') }}</a>
          <a class="txt" href="/contactUs/" target="_blank">{{ t('menu.contactUs') }}</a>
          <a class="txt" href="/FAQ/" target="_blank">{{ t('menu.faq') }}</a>
          <a class="txt">{{ t('common.liveTime') }}</a>
        </div>
      </div>

      <div class="footer-logo-container">
        <div class="flexlist footer-info-list">
          <div class="logolist phone-logolist">
            <div class="titbox">{{ t('common.callUs') }}</div>
            <div class="footer-phone-list">
              <div class="footer-phone-row" v-for="contact in phoneContacts" :key="contact.region">
                <img :src="contact.icon" class="footer-phone-flag" alt="" />
                <span>{{ contact.number }}</span>
              </div>
            </div>
          </div>
          <!-- Follow Us Logos-->
          <div class="logolist">
            <div class="titbox">{{ t('common.followUs') }}</div>
            <div class="linklogo">
              <a href="https://www.facebook.com/triptogo.usa/ " target="_blank">
                <img src="/images/footer/icon1.png" class="icon" alt="facebook"
              /></a>
              <a href="https://x.com/TripToGo_USA" target="_blank">
                <img src="/images/footer/icon2.png" class="icon" alt="X"
              /></a>
              <a href="https://www.instagram.com/triptogo_usa/ " target="_blank">
                <img src="/images/footer/icon3.png" class="icon" alt="instagram"
              /></a>
              <a href="https://www.youtube.com/@TripToGo_explore " target="_blank">
                <img src="/images/footer/icon4.png" class="icon" alt="youtube"
              /></a>
              <a href="https://www.tiktok.com/@triptogo.com " target="_blank">
                <img src="/images/footer/icon6.png" class="icon" alt="tiktok" />
              </a>
            </div>
          </div>
          <!-- Payment Methods Logos-->
          <div class="logolist">
            <div class="titbox">{{ t('common.payMethods') }}</div>
            <div class="paybox">
              <img src="/images/footer/icon7.png" class="icon" alt="" />
              <img src="/images/footer/icon8.png" class="icon" alt="" />
              <img src="/images/footer/icon9.png" class="icon" alt="" />
              <!--         <img src="/images/footer/icon10.png" class="icon" alt="">  -->
              <img src="/images/footer/paypal.png" class="icon" alt="" />
            </div>
          </div>
        </div>
        <!-- Charity Logos -->
        <div :class="[width < 750 ? 'flexlist' : null]" class="charity-container">
          <div class="logolist">
            <div class="titbox">{{ t('common.inSupportOf') }}</div>
            <div class="charity-logo-box-wrapper">
              <div class="charity-logo-box">
                <img
                  v-for="(item, index) in charityList1"
                  :key="index"
                  :src="item.src"
                  class="icon"
                  :alt="item.alt"
                  :width="item.defaultWidth"
                />
              </div>
              <div class="charity-logo-box">
                <img
                  v-for="(item, index) in charityList2"
                  :key="index"
                  :src="item.src"
                  class="icon"
                  :alt="item.alt"
                  :width="item.defaultWidth"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="copyright">
        <div
          class="cp_img childcenter"
          style="display: flex; justify-content: center; align-items: center"
        >
          <!--  <img src="/images/footer/TravelBrandLogo.png" class="tico1" alt="TravelBrand">
                          <img src="/images/footer/f1.png" class="tico1" alt="">
                          -->
          <img src="/images/footer/f2.png" class="tico1" alt="" />
          <img src="/images/footer/f3.png" class="tico" alt="" />
          <img src="/images/footer/f4.png" class="tico" alt="" />

          <img src="/images/logo_tico.png" class="tico" alt="tico" />
          <img src="/images/footer/PATALogo.png" class="tico" alt="PATALogo" />
        </div>

        <div class="block childcenter reg_number">
          <div style="justify-content: center">
            <!-- <div>TICO Registration Number:</div>
              <div>50027720(wholesale)</div> -->
            <div>Copyright © TripToGo. {{ t('common.copyright') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import vGtag from '@/directives/GtagDirective'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useWindowSize } from '@vueuse/core'
import { useHomepagePhoneContacts } from '@/composables/homepage'
const { t } = useI18n()

const { width } = useWindowSize()
const { phoneContacts } = useHomepagePhoneContacts()

const charityList1 = computed(() => [
  {
    src: `/images/footer/charity_logos/footer_logo_1_BCHbenefiting_desktop.svg`,
    alt: 'BCHbenefiting',
    defaultWidth: width.value >= 1422 ? 256 : 230
  },
  {
    src: `/images/footer/charity_logos/footer_logo_2_sickKids_desktop.svg`,
    alt: 'sickKids',
    defaultWidth: width.value >= 1422 ? 'auto' : 88
  }
])
const charityList2 = computed(() => [
  {
    src: `/images/footer/charity_logos/footer_logo_3_charitywater_desktop.svg`,
    alt: 'charitywater',
    defaultWidth: width.value >= 1422 ? 'auto' : 128
  },
  {
    src: `/images/footer/charity_logos/footer_logo_4_arbor_desktop.svg`,
    alt: 'arbor',
    defaultWidth: width.value >= 1422 ? 'auto' : 100
  }
])
</script>

<!-- Legacy Desktop First Styles-->
<style scoped>
.cp_img {
  flex-wrap: wrap;
  gap: 4rem;
  margin-bottom: 2rem;
}
.footer {
  background: #fff;
  box-sizing: border-box;
  margin-top: 72px;
}
.footer .conbox {
  padding-top: 5.7rem;
  border-top: 0.3rem solid #000000;
  position: relative;
}
.footer .logobox {
  background: #fff;
  padding: 0 4.4rem;
  position: absolute;
  left: calc(50% - 13.55rem);
  top: -2rem;
}
.footer .logobox .logo {
  width: 18.3rem;
  margin: 0 auto;
}
.footer .titbox {
  font-size: 1.7rem;
  font-weight: 700;
  font-family: 'Poppins', sans-serif;
  line-height: 2.4rem;
  letter-spacing: 0.04em;
  color: #333;
}
.footer .logolist {
  min-width: 25%;
}
.footer .flexlist .linklogo {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.footer .flexlist .linklogo .icon {
  width: 1.6rem;
  height: 1.6rem;
  margin-right: 2.2rem;
}
.footer .flexlist .paybox {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 1.1rem 0 0;
  margin-bottom: 12px;
}
.footer .flexlist .paybox .icon {
  max-width: 7.8rem;
  max-height: 30px;
  margin-right: 1.6rem;
}
.footer .footer-phone-list {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 0.6rem;
  align-items: flex-start;
  margin-top: 0.8rem;
}
.footer .footer-phone-row {
  display: flex;
  gap: 0.8rem;
  align-items: center;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 2rem;
  color: #333;
  white-space: nowrap;
}
.footer .footer-phone-row:not(:last-child)::after {
  content: none;
  margin-left: 0.6rem;
  color: #cccccc;
}
.footer .footer-phone-flag {
  width: 1.6rem;
  height: 1.6rem;
  flex: 0 0 auto;
}
.footer .listflex {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 2.4rem 1.8rem 4rem;
  border-bottom: 0.2rem solid #000000;
}
.footer .listflex .list {
  width: 25%;
}
.footer .listflex .list a {
  display: block;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 1.6rem;
  text-align: left;
  color: #333;
  margin-bottom: 1.2rem;
}
.footer .listflex .list a.tit {
  font-size: 1.7rem;
  font-weight: 700;
  line-height: 2rem;
  letter-spacing: 0.04em;
  margin-bottom: 1.6rem;
}
.footer .copyright {
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 2rem;
  text-align: center;
  color: #666666;
  box-sizing: border-box;
}
.footer .copyright .tico {
  width: 8rem;
  display: flex;
}
.footer .copyright .tico1 {
  width: 8rem;
  display: flex;
}
.footer .reg_number {
  margin-top: 3rem;
}
</style>
<style scoped>
@media screen and (max-width: 750px) {
  /* Mobile type on the Voyada V2 scale: headings 16, body 14, small print 12, line-height 1.5. */
  .footer .titbox {
    font-size: 1.6rem;
    line-height: 2.4rem;
  }
  .footer .listflex .list a {
    font-size: 1.4rem;
    line-height: 2.1rem;
  }
  .footer .listflex .list a.tit {
    font-size: 1.6rem;
    line-height: 2.4rem;
  }
  .footer .footer-phone-row {
    font-size: 1.4rem;
    line-height: 2.1rem;
  }
  .footer .copyright {
    font-size: 1.2rem;
    line-height: 1.8rem;
  }

  .footer {
    margin-top: 6rem;
  }
  .footer .logobox {
    padding: 0 3rem;
    left: calc(50% - 12.15rem);
  }
  .footer .conbox {
    padding-top: 0;
    border-top: 0;
  }
  .footer .logobox {
    position: relative;
    top: auto;
    left: auto;
    width: max-content;
    margin: 0 auto;
  }
  .footer .listflex {
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 2.4rem 0 1.2rem;
    border-bottom: 0.2rem solid #000000;
  }
  .footer .listflex .list {
    width: 48%;
    margin-top: 1.2rem;
  }
  .footer .copyright .tico {
    width: 4rem;
  }
  .footer .copyright .tico1 {
    width: 8rem;
  }
}
</style>

<!-- Mobile First Styles-->
<style scoped>
/* Default Mobile Styles */
.footer-logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 24px;
}

.footer .flexlist {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  width: 90%;
}

.footer .logolist {
  min-width: 100%;
  margin-top: 12px;
}

.footer .phone-logolist {
  margin-top: 0;
}

.charity-logo-box-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: row;
}

.footer .flexlist .linklogo,
.footer .flexlist .paybox,
.footer .flexlist .charity-logo-box {
  margin-top: 8px;
}

.cp_img {
  gap: 8px;
  /* gap between images */
}

.footer .flexlist .charity-logo-box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 8px 0 0;
  flex-wrap: wrap;
  gap: 8px;
  align-self: stretch;
}

.footer .flexlist .charity-logo-box:first-child {
  margin-right: 12px;
}

.copyright {
  padding: 24px 0;
}

/* Desktop Styles */
@media screen and (min-width: 750px) {
  .footer-logo-container {
    margin-top: 0;
  }

  .footer .flexlist {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: nowrap;
    padding-top: 0;
    margin-top: 32px;
    margin-bottom: 0;
    width: 60%;
  }

  .footer .flexlist .linklogo,
  .footer .flexlist .paybox,
  .footer .flexlist .charity-logo-box {
    margin-top: 12px;
  }

  .cp_img {
    gap: 20px;
  }

  .charity-logo-box {
    margin-top: 12px;
    display: flex;
  }

  .charity-logo-box .icon {
    margin-right: 12px;
  }

  .footer .footer-info-list {
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: nowrap;
    width: 100%;
    max-width: 104rem;
    gap: 8rem;
  }

  .footer .footer-info-list .logolist {
    min-width: auto;
    margin-top: 0;
  }

  .footer .footer-phone-list {
    flex-direction: row;
    flex-wrap: nowrap;
    margin-top: 12px;
  }

  .footer .footer-phone-row:not(:last-child)::after {
    content: '|';
  }

  .charity-container {
    width: 376px;
    max-width: 376px;
  }

  .footer .logolist {
    min-width: 50%;
    margin-top: 0;
  }
  .linklogo {
    margin-bottom: 0;
  }

  .copyright {
    padding: 32px 0 70px 0;
  }
}

@media screen and (min-width: 1422px) {
  .footer .footer-info-list {
    max-width: 116rem;
    gap: 12rem;
  }

  .charity-container {
    width: auto;
    max-width: 100%;
  }
}
</style>
